import React from 'react'
import IncomeAttributeLookupObject from '../../../types/lookups/IncomeAttributeLookupObject';
import IncomeAttributeTableFragmentGenerator from '../../../utils/TableGenerator/IncomeAttributeTableFragmentGenerator';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useShowIncomeLabel } from '../../../utils/ShowIncomeLabelContext';
import { selectMenu } from '../../../redux/selectors/exportSelectorPaths';

export interface IncomeAttributeTableTabProps {
    handleCurrencyChange: (newAmt: number | undefined | null, name: string, oldAmt: number | undefined | null) => void,
    handleCommentChange: (value: string, name: string) => void,
    lookups: IncomeAttributeLookupObject[],
    incomeAttributes?: Record<string, unknown>[]
}

function IncomeAttributeTableTab(props: IncomeAttributeTableTabProps) {
    const { handleCommentChange, handleCurrencyChange, lookups } = props
    const { t } = useTranslation("pie");
    const replacementReserveAttributeCode = "50";
    const menuState = useSelector(selectMenu);
    const activeMenuName = menuState.activeItem.name;
    const required = t(activeMenuName + ".required");
    const requiredAttributeCodes: string[] = required.endsWith(".required") ? [] : JSON.parse(required);
    const { showIncomeLabel } = useShowIncomeLabel()


    return (
        <>
            {lookups &&
                <table className="table-with-border pie-table">
                    <thead>
                        <tr>
                            {showIncomeLabel && <th id="attribute-label" scope="col"></th>}
                            <th id="attribute-value" scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            lookups.map((attr, key) => {
                                let incomeAttributesData: Record<string, unknown> | undefined = undefined;
                                if (props.incomeAttributes) {
                                    incomeAttributesData = (props.incomeAttributes.find(({ code }) => code === attr.incomeAttributeCode));
                                }
                                if (["7", "114"].includes(attr.incomeAttributeCode)) {
                                    return <IncomeAttributeTableFragmentGenerator key={key} attribute={attr}
                                        data={incomeAttributesData}
                                        handleCommentChange={handleCommentChange}
                                        valueChangeHandler={handleCurrencyChange}
                                        showSubheading={false}
                                        hasInputLabel={true} isPlaceHolderWithAttrDesc={true}
                                        isOtherLabel={false}
                                        isRequiredField={requiredAttributeCodes.includes(attr.incomeAttributeCode)}
                                        isReplacementReserve={replacementReserveAttributeCode === attr.incomeAttributeCode}
                                    />
                                } else {
                                    return <IncomeAttributeTableFragmentGenerator key={key} attribute={attr}
                                        data={incomeAttributesData}
                                        handleCommentChange={handleCommentChange}
                                        valueChangeHandler={handleCurrencyChange}
                                        showSubheading={false}
                                        hasInputLabel={false}
                                        isOtherLabel={false}
                                        isRequiredField={requiredAttributeCodes.includes(attr.incomeAttributeCode)}
                                        isReplacementReserve={replacementReserveAttributeCode === attr.incomeAttributeCode}
                                    />
                                }
                            }
                            )
                        }
                    </tbody>
                </table>
            }
        </>
    )
}

export default IncomeAttributeTableTab